const zh = {
    "global.turnOffMicrophone": "关闭麦克风",
    "global.turnOnMicrophone": "打开麦克风",
    "global.turnOffCamera": "关闭摄像头",
    "global.turnOnCamera": "打开摄像头",
    "global.settings": "设置",
    "global.documentation": "文档",
    "global.you": "您",
    "global.flip": "翻转",
    "global.roomDetails": "房间详情",
    "global.copied": "已复制",
    "global.roomMembers": "房间成员",
    "global.search": "查找",
    "global.noSearchResults": "没有搜索结果",
    "global.roomMessages": "房间消息",
    "global.send": "向所有人发送消息",
    "global.leaveDialogTitle": "离开房间",
    "global.leaveDialogDesc": "您确定要离开房间吗？",
    "global.confirm": "确认",
    "global.cancel": "取消",
    "global.leftRoom": "您已离开房间。",
    "global.rejoin": "重新加入",
    "global.return": "返回首页",
    "global.joining": "加入房间",
    "global.network": "您的网络出现问题，正在尝试重新连接...",
    "global.networkMobile": "正在尝试重新连接...",
    "global.mute": "静音",
    "global.stop": "停止",
    "global.enter": "进入",
    "global.quit": "退出",
    "global.room": "房间",
    "global.agree": "同意",
    "global.disagree": "不同意",
    "global.notice": "注意",
    "global.loading": "加载中...",
    "global.loginRoomFailed": "登录房间失败",
    "global.equipment": "设备授权",
    "global.equipmentDesc": "我们无法检测到您的设备。请检查您的设备，并允许我们在浏览器的地址栏中访问您的设备，然后重新加载此页面。",
    "global.micPermission": "视频通话场景中，请先授予麦克风权限，再操作设备",
    "global.cameraPermission": "视频通话场景中，请先授予摄像头权限，再操作设备",
    "global.browserNotSupportSharing": "您的浏览器不支持屏幕共享。",
    "global.shareAuthority": "授予共享屏幕的访问权限",
    "global.shareAuthorityDesc": "您的系统没有浏览器共享屏幕的权限，请在系统设置上授予共享屏幕的访问权限。",
    "global.tooFrequent": "操作过于频繁，无法加载白板。",
    "global.joinRoomFailedDesc": "加入房间失败，房间中的人数已达到最大值。（2人）",
    "global.joinRoomFailedNetwork": "您的网络出现问题，请检查并重试。",
    "global.joinRoomFailedToken": "加入房间失败，token 验证错误。",
    "global.joinRoomFailedRepeat": "您在另一个房间，请先离开那个房间。",
    "global.joinRoomFailed": "加入房间失败，请重试。（错误码：{code}）",
    "global.inviteMembers": "邀请成员",
    "global.invitees": "受邀请人",
    "global.checkRTC": "该设备不支持 rtc 功能，请尝试其他设备",

    "browserCheck.join": "加入",
    "browserCheck.placeholder": "您的姓名",
    "browserCheck.shareTitle": "分享链接",
    "browserCheck.cameraDesc": "摄像机已关闭",
    "browserCheck.cameraStart": "摄像头正在启动...",


    "room.microphoneStatus": "麦克风",
    "room.on": "已打开",
    "room.off": "已关闭",
    "room.cameraStatus": "摄像头",
    "room.presentingDesc": "您正在向所有人共享",
    "room.stopPresenting": "结束共享",
    "room.presentingMirrorTip": "为避免无限镜像，建议您不要共享整个屏幕或浏览器窗口。",
    "room.ignore": "忽略",
    "room.live": "开始直播",
    "room.stopLive": "停止直播",
    "room.living": "直播即将开始...",
    "room.stopLiveDesc": "确定要停止直播吗？",
    "room.turnOffMicToast": "已成功关闭麦克风",
    "room.turnOffCameraToast": "已成功关闭摄像头",
    "room.sendInvitationSuccessToast": "邀请发送成功。",
    "room.sendInvitationFailToast": "发送邀请失败，请重试",
    "room.sendInvitation": "邀请已发送。",
    "room.copyToast": "复制成功",
    "room.noOneStreaming": "还没有人打开摄像头或麦克风",
    "room.chageLayout": "更改布局",
    "room.fullScreen": "全屏",
    "room.exitFullScreen": "退出全屏",
    "room.remove": "踢出房间",
    "room.removeDesc": "确定要将 {user} 踢出房间吗？",
    "room.removePin": "取消 Pin",
    "room.autoLayout": "自动",
    "room.gridLayout": "网格",
    "room.sidebarLayout": "侧边栏",
    "room.liveNotStarted": "直播尚未开始",
    "room.invite": "邀请连麦",
    "room.endConnection": "结束连麦",
    "room.endConnectionDesc": "您确定要结束连麦吗？",
    "room.invitationDialogTitle": "邀请",
    "room.invitationDialogDesc": "主播邀请您连麦",
    "room.appliedConnectionToast": "您正在申请连麦，请等待确认。",
    "room.hostLeftToast": "主播已离开房间",
    "room.appliedFailToast": "发送邀请失败，请重试。",
    "room.disagreedInvitationToast": "{user} 拒绝连麦",
    "room.InvitationSent": "邀请已发送",
    "room.turnedCameraOff": "{user} 已关闭您的摄像头",
    "room.turnedMicOff": "{user} 已关闭您的麦克风",
    "room.requestingConnectionToast": "{user} 想与您连麦",
    "room.rejectedRequestToast": "您的连麦申请已被拒绝",
    "room.occupiedToast": "音频和视频设备正被另一个应用程序占用",
    "room.otherScreenPresentingToast": "{user} 正在共享。您无法共享您的屏幕。",
    "room.otherWhiteboardPresentingToast": "{user} 正在共享。您无法共享您的白板。",
    "room.presenting": "{user} 正在共享屏幕",
    "room.presentingFailed": "共享屏幕失败。错误码：{code}",
    "room.requestExpired": "连麦请求已过期",
    "room.browserNotSupport": "您当前的浏览器不支持在直播间显示多个视频屏幕",
    "room.serviceNotAvailable": "该服务不可用，请联系直播服务提供商解决",
    "room.resumePlayTips": "浏览器阻止音视频播放，请点击“恢复播放”。",
    "room.resumePlay": "恢复播放",
    "room.banSending": "禁止发言",
    "room.cancelBanSending": "取消禁言",

    "mobileRoom.member": "成员",
    "mobileRoom.chat": "聊天",
    "mobileRoom.whiteboard": "白板",
    "mobileRoom.layout": "布局",
    "mobileRoom.presenting": "{user} 正在共享",
    "mobileRoom.browserNotSupport": "当前浏览器不支持显示多个视频屏幕，建议您更改浏览器。",
    "mobileRoom.connect": "申请连麦",

    "settings.audio": "音频",
    "settings.video": "视频",
    "settings.microphone": "麦克风",
    "settings.speakers": "扬声器",
    "settings.camera": "摄像头",
    "settings.preview": "预览",
    "settings.resolution": "分辨率",
    "settings.test": "测试",
    "settings.showVideo": "显示非视频参与者",

    "call.calling": "正在呼叫...",
    "call.endCall": "结束通话",
    "call.cancelToast": "通话已取消",
    "call.incoming": "来电...",
    "call.decline": "拒绝",
    "call.accept": "接受",
    "call.cancelled": "已取消邀请",
    "call.incomingVoice": "{group}语音来电...",
    "call.incomingVideo": "{group}视频来电...",
    "call.cancelCall": "取消通话",
};
export default zh;